import { computed } from 'vue'

// See ./README.md for permission composition semantics and examples.
export type PermissionResult = {
  allowed: boolean
  reasons: string[]
}

export function check(allowed: boolean, message: string): PermissionResult {
  return { allowed, reasons: allowed ? [] : [message] }
}

export function allOf(first: PermissionResult, ...rest: PermissionResult[]): PermissionResult {
  const checks = [first, ...rest]
  return {
    allowed: checks.every((permission) => permission.allowed),
    reasons: [...new Set(checks.flatMap((permission) => permission.reasons))],
  }
}

export function anyOf(first: PermissionResult, ...rest: PermissionResult[]): PermissionResult {
  const checks = [first, ...rest]
  const allowed = checks.some((permission) => permission.allowed)
  return {
    allowed,
    reasons: allowed ? [] : [...new Set(checks.flatMap((permission) => permission.reasons))],
  }
}

export function usePermission(evaluate: () => PermissionResult) {
  const permission = computed(evaluate)
  const allowed = computed(() => permission.value.allowed)
  const reasons = computed(() => permission.value.reasons)

  return { permission, allowed, reasons }
}
